import React from 'react';

import { Box, Typography } from '@mui/material';

import type { HealthProperty } from './types';

const FEEDS = {
  commercial: 'sales and margin',
  impressions: 'package impressions',
  parity: 'price comparisons',
} as const;

export default function DataCoverage({ property, date }: { property: HealthProperty; date: string }) {
  const missing = Object.entries(FEEDS)
    .filter(([key]) => property.evidence[key as keyof typeof FEEDS] !== 'observed')
    .map(([, label]) => label);
  return (
    <Box sx={{ maxWidth: '100ch' }}>
      <Typography variant="subtitle2" gutterBottom>
        When a figure is missing
      </Typography>
      <Typography variant="body2" color="text.secondary">
        A dash means no usable figure was recorded for the selected period. Property mapping is shown separately under
        LPP connection. Missing records are not displayed as $0.
      </Typography>
      {missing.length > 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          No records on {date} for {missing.join(', ')}.
        </Typography>
      )}
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1, overflowWrap: 'anywhere' }}>
        Hotel reference: {property.property_id}
      </Typography>
    </Box>
  );
}
